<script setup lang="ts">
    import { Toaster } from 'vue-sonner';
    import { LoaderCircle, Check, CircleCheck } from 'lucide-vue-next';
</script>

<template>
    <Toaster
        position="top-right"
        expand
        :visible-toasts="10"
        :toastOptions="{
            unstyled: true,
            classes: {
                toast: 'flex w-[var(--width)] items-center gap-2 rounded border p-4 text-xs text-white shadow-md font-sans',
                content: 'flex flex-col gap-1',
                description: 'font-bold text-sm',
                success: 'bg-secondary/80 border-secondary',
                error: 'bg-destructive/80 border-destructive',
            },
        }"
    >
        <template #loading-icon>
            <LoaderCircle class="size-4.5 animate-spin text-white" />
        </template>
        <template #success-icon>
            <CircleCheck class="size-4.5 text-white" />
        </template>
    </Toaster>
</template>
